import script from "./SupplierProductView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupplierProductView.vue?vue&type=script&lang=ts&setup=true"

import "./SupplierProductView.vue?vue&type=style&index=0&id=1c614192&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c614192"]])

export default __exports__